<template>
  <v-row justify="center">
    <v-dialog
      :value="value"
      max-width="300px"
      @click:outside="closeDialog"
      @keydown.esc="closeDialog"
    >
      <v-card>
        <v-card-title>
          {{ $t('profile.languagePickerHeader') }}
        </v-card-title>
        <v-divider></v-divider>
        <v-card-text>
          <v-radio-group
            v-model="selectedLanguage"
            column
          >
            <v-radio
              v-for="language in languages"
              :key="language.value"
              :label="language.label"
              :value="language.value"
            ></v-radio>
          </v-radio-group>
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn @click="closeDialog" text>
            {{ $t('close') }}
          </v-btn>
          <v-btn
            color="primary"
            :disabled="loading"
            :loading="loading"
            @click="selectLocale"
          >
            {{ $t('save') }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-row>
</template>

<script>
  import _ from 'lodash'
  import {mapGetters, mapActions} from 'vuex'
  import {setLocale} from '@/utils'

  export default {
    props: {value: Boolean},
    data() {
      return {
        selectedLanguage: this.$i18n.locale,
        loading: false
      }
    },
    computed: {
      ...mapGetters(['isAuthenticated']),
      i18n() {
        return _.get(this.$store.getters.extensionSettings, 'i18n')
      },
      languages() {
        if (this.i18n && !_.isEmpty(this.i18n.languages)) {
          return this.i18n.languages.map((language) => {
            return {
              value: language,
              label: this.$t(`languages.${language}`)
            }
          })
        }

        return []
      }
    },
    methods: {
      ...mapActions(['updateUserLocale']),
      async selectLocale() {
        try {
          this.loading = true
          if (this.isAuthenticated) {
            await this.updateUserLocale(this.selectedLanguage)
          } else {
            await setLocale(this.selectedLanguage)
          }
          this.loading = false
          location.reload()
        } catch (error) {
          this.loading = false
        }
      },
      closeDialog() {
        this.$emit('close')
      }
    },
  }
</script>
